import { useEffect, useRef } from "react";
import { CrmService } from "../../../../services/CrmService";
import { AdminService } from "../../../../services/AdminService";
import { ChangeAlertCallbackType } from "../../../Root";

export const useCRMFunction = (changeAlert: ChangeAlertCallbackType) => {
    const crmService = useRef<CrmService>();
    const adminService = useRef<AdminService>();

    // GET __________________________________________________

    const onHandleGetData = async (payload, service) => {
        const response = await crmService.current[service](payload);
        if (response["data"]?.response === "OK") {
            return response.data["content"] ? response.data : response.data.widget.length > 0 
                ? response.data.widget[0].data : { content: [] };
        } else {
            changeAlert(true, "error", response["data"].message || "Error al consultar servicio");
            return false;
        }
    };

    const onHandleGetByUuid = async (payload, tab) => {
        let req = { filters: payload };
        let service = tab === "seller" ? "sellerCrmGet" : "commissionCrmGet";

        const response = await crmService.current[service](req);
        if (response["data"]?.response === "OK") {
            return response.data["content"];
        } else {
            changeAlert(true, "error", response["data"].message || "Error al consultar servicio");
            return false;
        }
    };

    const onHandleAgentList = async () => {
        let role = "inext-role-afb-kam";
        const response = await adminService.current.agentByRoleList(role);
        if (response["data"]?.response === "OK") {
            return JSON.parse(JSON.stringify(response.data.content));
        } else {
            changeAlert(true, "error", response["message"] || response["data"]["message"] || "Error al consultar servicio");
            return false;
        }
    };

    const onGetAgentByUuid = async (uuid) => {
        const response = await adminService.current.agentByUuid({ uuid: uuid });
        if (response["data"]?.response === "OK") {
            return JSON.parse(JSON.stringify(response.data.content));
        } else {
            changeAlert(true, "error", response["message"] || response["data"]["message"] || "Error al consultar servicio");
            return false;
        }
    };

    // COMMISSION __________________________________________________

    const onHandleCommissionCreate = async (payload) => {
        const response = await crmService.current.commissionCrmCreate(payload);
        if (response.data?.response === "OK") {
            changeAlert(true, "success", "La comisión se registró con éxito");
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al crear comisión");
            return false;
        }
    };

    const onHandleCommissionUpdate = async (payload, agent) => {
        let request = {
            detail: payload,
            updated_by: agent["uuid"],
        };

        const response = await crmService.current.commissionCrmUpdate({data: request});
        if (response["data"]?.response === "OK") {
            changeAlert(true, "success", "Comisiones asignadas con éxito.");
            return true;
        } else {
            changeAlert(true, "error", response["message"] || response["data"].message || "Error al asignar comisiones");
            return false;
        }
    };

    // SELLERS __________________________________________________

    const onHandleSellerCreate = async (payload) => {
        const response = await crmService.current.sellerCrmCreate({data: payload});
        if (response.data?.response === "OK") {
            changeAlert(true, "success", response["data"]["content"]["restored"] ?
                "Se reestableció el registró del vendedor, verifica que sea correcto y Activa su Estatus si corresponde." : "El vendedor se registró con éxito");
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al registrar vendedor");
            return false;
        }
    };

    const onHandleSellerUpdate = async (payload) => {
        const response = await crmService.current.sellerCrmUpdate({data: payload});
        if (response.data?.response === "OK") {
            changeAlert(true, "success", "El registro se actualizó con éxito");
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al actualizar vendedor");
            return false;
        }
    };

    useEffect(() => {
        crmService.current = new CrmService(changeAlert);
        adminService.current = new AdminService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        onHandleGetData,
        onHandleGetByUuid,
        onHandleAgentList,
        onGetAgentByUuid,
        // Commission
        onHandleCommissionCreate,
        onHandleCommissionUpdate,
        // Seller
        onHandleSellerCreate,
        onHandleSellerUpdate,
    };
};
